<template>
<v-card flat class="mt-4">
    <v-card-text>
        <p class="text-h6 text--primary mb-6">
            {{title}}
        </p>
        <v-data-table :headers="headers" :items="itemList" :hide-default-footer="true" :loading="isExporting" :items-per-page="itemList.length"></v-data-table>
    </v-card-text>
</v-card>
</template>
<script>
import formatData from "../utils/formatData";
import {
    onsiteConfig
} from '@/helpers/onsiteConfig'
export default {
    data() {
        return {
            title: 'ผลการประเมินพฤติกรรมตนเอง',
            onsiteConfig: onsiteConfig,
            search: "",
            options: {
                itemsPerPage: 20,
            },
            isExporting: false,
            headers: [{
                text: "",
                value: "name",
                sortable: false
            }, {
                text: "ก่อนโปรแกรม",
                value: "preData",
                sortable: false
            }, {
                text: "ความเสี่ยง",
                value: "preRisk",
                sortable: false
            }, {
                text: "หลังโปรแกรม",
                value: "postData",
                sortable: false
            },{
                text: "ความเสี่ยง",
                value: "postRisk",
                sortable: false
            },{
                text: "% เปลี่ยนแปลง",
                value: "percentDiff",
                sortable: false
            }],
            itemList: []
        };
    },
    created() {
        (async () => {
            for (const [key] of Object.entries(onsiteConfig['survey'])) {
                //set name
                const itemListHash = {
                    name: onsiteConfig['survey'][key]['title'],
                };

                itemListHash['preData'] = this.programInfo.survey['pre' + key];
                itemListHash['preRisk'] = this.calculateRiskPoint(key, itemListHash['preData']);
                itemListHash['postData'] = this.programInfo.survey['post' + key];
                itemListHash['postRisk'] = this.calculateRiskPoint(key, itemListHash['postData']);
                

                //TODO calculate before and after
                //TODO calculate only field match for 1 & 6
                //TODO skip if empty or undef value
                itemListHash['percentDiff'] = '-';
                if (itemListHash['preData'] != '-' && itemListHash['postData'] != '-') {
                    itemListHash['percentDiff'] = ((itemListHash['postData'] - itemListHash['preData']) / itemListHash['preData']) * 100;
                    itemListHash['percentDiff'] = formatData('number', itemListHash['percentDiff']);
                }

                this.itemList.push(itemListHash);
            }
        })();
    },
    computed: {
        programInfo() {
            return this.$attrs.programInfo;
        }
    },
    methods: {
        calculateRiskPoint(key, point){
            if( onsiteConfig['survey'][key]['riskPoint'] != undefined ){
                for (const [key1, value1] of Object.entries(onsiteConfig['survey'][key]['riskPoint']) ){
                    const [startPoint, endPoint] = key1.split('-');
                    if( point >= startPoint && point <= endPoint ){
                        return value1;
                    }
                }
            }
        }
    }
};
</script>
